import { RegisteredEmployeeView, SortableRegisteredEmployeeField } from '@iota/inh-core-v1-management-client';
import { createAction, props } from '@ngrx/store';

export type RegisteredEmployeeStatus = 'ACTIVE' | 'FORMER';

export interface RegisteredEmployeeOverviewPageParams {
    pageIndex: number;
    pageSize: number;
    companyIds?: string[]; // empty/undefined → all companies
    searchQuery?: string;
    status: RegisteredEmployeeStatus;
    sortingField?: SortableRegisteredEmployeeField;
    sortingAscending?: boolean;
}

export interface RegisteredEmployeeCounts {
    active: number;
    former: number;
}

export const LoadRegisteredEmployeeList = createAction(
    '[RegisteredEmployee] LoadRegisteredEmployeeList',
    props<{ params: RegisteredEmployeeOverviewPageParams }>()
);
export const LoadRegisteredEmployeeListSuccess = createAction(
    '[RegisteredEmployee] LoadRegisteredEmployeeListSuccess',
    props<{
        employees: RegisteredEmployeeView[];
        totalElements: number;
        pageIndex: number;
        pageSize: number;
    }>()
);
export const LoadRegisteredEmployeeListFailure = createAction(
    '[RegisteredEmployee] LoadRegisteredEmployeeListFailure',
    props<{ error: any }>()
);

export const LoadRegisteredEmployeeCounts = createAction('[RegisteredEmployee] LoadRegisteredEmployeeCounts');
export const LoadRegisteredEmployeeCountsSuccess = createAction(
    '[RegisteredEmployee] LoadRegisteredEmployeeCountsSuccess',
    props<{ counts: RegisteredEmployeeCounts }>()
);
export const LoadRegisteredEmployeeCountsFailure = createAction(
    '[RegisteredEmployee] LoadRegisteredEmployeeCountsFailure',
    props<{ error: any }>()
);
